<template>
	<ValidationProvider
		v-slot="{ errors, ariaInput, ariaMsg }"
		:name="name || label"
		:rules="rules"
		:vid="vid"
		class="text-input-wrap"
		tag="div"
	>
		<label
			v-if="!isHiddenLabel"
			:for="edit && name"
			class="text-input-label"
			@click="focusInput"
		>
			<span>{{ label || name }}</span>
			<slot name="right-label" />
		</label>

		<div class="text-input-holder">
			<template v-if="edit">
				<input
					:id="name"
					ref="input"
					:autocomplete="autocomplete"
					:class="{ 'validation-error': errors[0], 'has-value': hasValue, focused }"
					:disabled="disabled"
					:placeholder="placeholder"
					:type="type"
					:value="value"
					class="text-input"
					v-bind="ariaInput"
					@focus="onFocus"
					@blur="onBlur"
					@input="updateValue($event)"
					@keyup.enter="updateValue($event.target.value, 'enter')"
				>
			</template>
			<div v-else class="text-input text-mode">
				{{ value }}
			</div>
			<div class="text-input-tip">
				<slot name="tip" />
			</div>
			<div v-if="errors[0]" class="text-input-errors">
				<span v-bind="ariaMsg">
					{{ errors[0] }}
				</span>
			</div>
		</div>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { removeEmojis } from '~/assets/util/helpers/filters'

export default {
	name: 'TextInput',
	components: { ValidationProvider },
	props: {
		vid: {
			type: String,
			// eslint-disable-next-line no-undefined
			default: undefined
		},
		name: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		edit: {
			type: Boolean,
			default: true
		},
		rules: {
			type: [Object, String],
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		autocomplete: {
			type: String,
			default: 'on'
		},
		type: {
			type: String,
			default: 'text',
			validator (value) {
				return [
					'url',
					'text',
					'password',
					'tel',
					'search',
					'number',
					'email'
				].includes(value)
			}
		},
		value: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		focused: {
			type: Boolean,
			default: false
		},
		isHiddenLabel: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		hasValue () {
			return Boolean(this.value)
		}
	},
	methods: {
		onFocus () {
			this.$emit('focus')
			this.$emit('update:focused', true)
		},
		onBlur () {
			this.$emit('blur')
			this.$emit('update:focused', false)
		},
		focusInput () {
			if (this.edit && this.$refs.input) {
				this.$refs.input.focus()
			}
		},
		updateValue (event) {
			if (!event.target) {
				return false
			}
			const value = event.target.value
			if (value !== removeEmojis(value)) {
				return event.preventDefault()
			}
			this.$emit('input', value)
		}
	}
}
</script>
